import { Link, makeStyles, Text, tokens } from "@fluentui/react-components";
import * as React from "react";
import { CardSection } from "../../components/CardSection";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        padding: "2rem clamp(1rem, 5vw, 4rem)",
        width: "80%",
        margin: "0 auto",
        maxWidth: "1400px",
    },
    card: {
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: "12px",
        boxShadow: tokens.shadow16,
        padding: "1.5rem",
    },
    ul: {
        paddingLeft: "1.25rem",
        marginTop: "0.5rem",
        marginBottom: "0.5rem",
    }
});

export const Id = "77e2dcd8-8641-4676-ae34-5d12263dc23c";
export const Title = "Trust";
export const Subtitle = "Find out about how you can trust Ianus Guard";
export const Description = "Description on our security guidelines, measures and principles";
export const Keywords = ["security", "platform", "trust", "guideline"];

export const Component: React.FC = React.memo(() => {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <CardSection title="Three areas of trust">
                <Text>There is at least three areas in which to consider Trust:</Text>
                <ul className={styles.ul}>
                    <li>How can you trust Ianus Guard to protect your products and solutions?</li>
                    <li>How can you trust Ianus Guard to securely store and manage your data?</li>
                    <li>Trust in Ianua Software?</li>
                </ul>
                <Text>We treat all with equal importance. Here's how.</Text>
            </CardSection>

            <CardSection title="Trust in Product Protection">
                <Text>
                    Ianus Guard operates like a proven standard — think of OAuth.  
                    We issue cryptographically signed <strong>JSON Web Tokens (JWTs)</strong> as licenses, encoding:
                </Text>
                <ul className={styles.ul}>
                    <li><strong>Issuer</strong> – The publisher who approved the license</li>
                    <li><strong>Subject</strong> – The customer or environment licensed to use it</li>
                    <li><strong>Audience</strong> – The specific product/module covered</li>
                </ul>
                <Text>
                    These licenses are tamper-proof thanks to asymmetric encryption.  
                    And for full transparency, the validation libraries are <strong>open source</strong>:{" "}
                    <Link href="https://github.com/IanuaSoftware/Ianus-Clients" target="_blank">GitHub</Link>
                </Text>
            </CardSection>

            <CardSection title="Trust in the Ianus Guard Platform">
                <Text>
                    The Ianus platform enforces strict access control — only users you authorize can view publisher data or issue licenses.  
                    Roles are clearly defined to avoid accidental privilege escalation.
                </Text>
                <br />
                <Text>
                    <strong>Private key protection</strong> is core:  
                    Keys are generated and stored in a secure enclave, and cannot be exported — not even by our support team.
                    You alone control license authenticity.
                </Text>
            </CardSection>

            <CardSection title="Trust in Ianua Software">
                <Text>
                    At Ianua Software, we believe in quality, freedom, fairness and openness.
                    We want you to choose Ianus Guard for the advantages and comfort it provides, not because you're locked into it.
                    <br />
                    <br/>
                   
                    That’s why we encourage early dual-signing of your products:
                    <ul>
                        <li>Generate one key on Ianus Guard (our platform)</li>
                        <li>Generate a second key locally and store it securely</li>
                        <li>Configure both public keys in your clients</li>
                    </ul>

                    This gives you the flexibility to leave our platform anytime without risking service interruptions.
                    A detailled instruction on dual signing can be found on <Link href="https://github.com/Ianua-Software/Ianus-Clients/tree/main/standalone" target="_blank">GitHub</Link>.
                    <br/>
                    <br/>
                    We're confident in our service — but if you ever consider leaving, feel free to reach out. We're happy to hear your thoughts and improve where we can.
                </Text>
            </CardSection>
        </div>
    );
});
